import * as React from "react";
import styled from "styled-components";
import { getDays, getFirstDay } from "../utils"
import { Strings } from '--root/strings/en';

const STRINGS = Strings.dateTime;
const HEADER_HEIGHT = 32;
const CELL_SIZE = 32;
const WIDTH = CELL_SIZE * 7;

type MonthViewProps = {
    active?: Date   // The active date to highlight? Range support?
    date: Date      // The date to render
    onClick?: (date: Date) => void
    onMonthClick?: () => void
}

const Wrapper = styled.div<{width: number}>`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    >div{
        width: ${props => props.width}px;
    }

    >div>div:nth-child(1) {
        line-height: ${HEADER_HEIGHT}px;
        height: ${HEADER_HEIGHT}px;
        text-align: center;
    }
`;

const Heading = styled.div`
    ${props => props.theme.typography.heading5};
    margin: 0;
    cursor: ${props => props.onClick ? "pointer" : "initial"};
`;

const Row = styled.ol`
    display: flex;
    flex-wrap: wrap;
`;

const Label = styled.li<{width: number}>`
    ${props => props.theme.typography.body3}
    margin:0;
    color: ${props => props.theme.palette.text.secondary};
    flex: 0 0 ${props => props.width}px;
    height: ${props => props.width}px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Day = styled.li<{width: number, active?: boolean}>`
    ${props => props.theme.typography.body2}
    margin:0;
    color: ${props => props.theme.palette.text.primary};
    flex: 0 0 ${props => props.width}px;
    height: ${props => props.width}px;
    font-weight: ${props => props.active ? props.theme.typography.bold : 'initial'};
    border-radius: ${props => props.theme.radius.small};
    background: ${props => props.active ? props.theme.palette.ui.highlight : "initial"};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: ${props => props.onClick ? "pointer" : "initial"};
`;

const MonthView: React.FC<MonthViewProps> = (props) => {
    const { active, date, onClick, onMonthClick } = props;
    const activeYear = active?.getFullYear();
    const activeMonth = active?.getMonth();
    const activeDay = active?.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    const days = getDays(year, month);
    const firstDay = getFirstDay(year, month);
    return <Wrapper width={WIDTH}>
        <div>
            <Heading onClick={onMonthClick}>{STRINGS.months[month]} {year}</Heading>
            <Row>
                {STRINGS.daysShort.map(strDay => <Label width={CELL_SIZE}>{strDay}</Label>)}
            </Row>
            <Row>
                {[...Array(firstDay)].map(_=><Day width={CELL_SIZE}/>)}
                {[...Array(days)].map((_,idx)=> {
                    const isActive = activeYear == year && activeMonth == month && activeDay == idx+1;
                    return <Day width={CELL_SIZE} active={isActive} onClick={()=>onClick && onClick(new Date(year, month, idx+1))}>{idx+1}</Day>
                })}
            </Row>
        </div>
    </Wrapper>;
}

export default MonthView;
export { MonthView, MonthViewProps } 